<template>
	<div :class="['btn', { disabled }]" @click="doAction" @keyup.enter="doAction" role="button">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'Button',
	props: {
		action: {
			type: Function,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		doAction() {
			if (!this.disabled) {
				this.action();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.btn {
		display: block;
		padding: 1em 2.2em;
		margin: 20px 0;

		font-family: $heading-font;
		font-size: $font-size-lg;
		letter-spacing: $letter-spacing-plus;
		text-transform: uppercase;
		text-align: center;
		line-height: 1;

		border-width: $border-width-md;
		border-style: solid;
		transition: all $ui-transition-duration;
		user-select: none;

		&:focus,
		&:active,
		&:hover {
			cursor: pointer;
			outline: none;
		}

		&.filled {
			color: white;
			background: black;
			border-color: black;

			&:focus,
			&:active,
			&:hover {
				cursor: pointer;
				outline: none;
				background: $primary-color;
				border-color: $primary-color;
			}
		}

		&.close-btn {
			height: 25px;
			width: 25px;
			padding: 10px;
			color: $primary-color-extra-light;
			border: none;
			background-image: url('~@/assets/images/close-icon.svg');
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
			z-index: $z-top;

			@include desktop { padding: 15px; }
		}

		&.disabled {
			color: $primary-color-light;
			background: lighten($primary-color-dark, 20%);
			cursor: not-allowed;
		}

	}

	.view-previous-btn,
	.view-next-btn {
		background-image: url(../../assets/images/arrow.svg);
		background-position: center;
		background-repeat: no-repeat;
		border: none;
		height: 50px;
		width: 50px;
		padding: 0;

		// Kathryn killed this, she wants them always the smaller size
		@include tablet {
			// height: 75px;
			// width: 75px;
		}
	}

	.view-next-btn { transform: rotate(180deg); }
</style>
